import {
  Component,
  Input,
  LOCALE_ID,
} from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { Subject, Subscription, takeUntil } from 'rxjs';
import { BalanceService } from 'src/app/services/api/balance.service';
import { detailBalanceModel } from 'src/app/models/detail-balance.model';
import { ToastService } from 'src/app/services/toast.service';
import { NzMessageService } from 'ng-zorro-antd/message';
import { BypassApiService } from 'src/app/services/api/bypass.service';
import { ProfileService } from 'src/app/services/profile.service';
import { ResponseCustomType } from 'src/app/types/response/response.type';
import { environment } from 'src/environments/environment';

@Component({
  standalone: false,
  selector: 'app-detail-riwayat',
  templateUrl: './detail-riwayat-penarikan-saldo.component.html',
  styleUrls: ['./detail-riwayat-penarikan-saldo.component.scss'],
})
export class DetailRiwayatSaldoComponent {
  detailBalance: detailBalanceModel = {};
  destroy$ = new Subject();
  wdID!: number;
  Rekening!: string;

  @Input() paramsDetail = {
    withdrawal_id: this.wdID,
  };

  private profileSubscription!: Subscription;
  isEnterprise: boolean = false;

  constructor(
    private balanceService: BalanceService,
    private activeRoute: ActivatedRoute,
    private route: Router,
    private toastService: ToastService,
    private byPassService: BypassApiService,
    private profileService: ProfileService,
    private message: NzMessageService,
  ) { }
  ngOnInit(): void {
    this.getProfile()
  }

  getProfile() {
    this.profileSubscription = this.profileService.profileData$.subscribe((data) => {
      if (data) {
        this.isEnterprise = data.rajaongkir_level === 3;
        this.getDetailBalance();
      }
    });
  }

  back() {
    this.route.navigate(['finance/balance']);
  }

  getDetailBalance() {
    this.activeRoute.params.subscribe((params) => {
      this.wdID = Number(params['id']);
    });

    if (this.isEnterprise) {
      this.balanceService
        .detailWithdraw(this.wdID)
        .pipe(takeUntil(this.destroy$))
        .subscribe((res) => {
          this.detailBalance = res.data;
          this.Rekening = res.data.bank_number;
        });
    } else {
      this.byPassService
        .request<any>({
          method: 'GET',
          endpoint: `${environment.SWITCH_URL}/user/api/v1/withdrawal/detail/${this.wdID}`,
        })
        .pipe(takeUntil(this.destroy$))
        .subscribe({
          next: (res: ResponseCustomType<any>) => {
            this.detailBalance = res.data;
            this.Rekening = res.data.bank_number;
          },
          error: (err) => {
            this.message.create('error', err.error.meta.message);
          }
        });
    }
  }

  salinCode(): void {
    const norek = this.Rekening;
    navigator.clipboard
      .writeText(norek)
      .then(() => {
        this.toastService.show(
          null,
          'Account has been successfully copied',
          'success',
          {
            classname: 'bg-success',
            delay: 3000,
          }
        );
      })
      .catch((e) => console.log(e));
  }
}
